import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "@/data/profile";

const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [n, setN] = useState(0);
  const target = parseFloat(value);
  const decimals = value.includes(".") ? 1 : 0;

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / 1400, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      setN(target * eased);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, target]);

  return <span ref={ref}>{n.toFixed(decimals)}</span>;
};

export const Stats = () => (
  <section data-testid="stats-section" className="border-t hairline grid grid-cols-2 md:grid-cols-4">
    {STATS.map((s, i) => (
      <div
        key={s.label}
        data-testid={`stat-${i}`}
        className={`px-6 md:px-12 py-12 md:py-16 border-b hairline ${i < STATS.length - 1 ? "md:border-r" : ""} ${i % 2 === 0 ? "border-r md:border-r" : ""}`}
      >
        <div className="font-display text-6xl md:text-7xl leading-none">
          <Counter value={s.value} />
          <span className="text-[var(--accent)]">{s.suffix}</span>
        </div>
        <div className="eyebrow mt-4">{s.label}</div>
      </div>
    ))}
  </section>
);
